import { ReactElement } from 'react';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const ChangeThemeSkeleton = (): ReactElement => {
  return <Skeleton.Button shape="round" className="ChangeThemeSkeleton" />;
};
